import { IGroupElement } from '../question/types';

const re = /\s|[^a-zA-Z0-9]+/g;

export const getLabelId = (element: IGroupElement) =>
  element.label?.replaceAll(re, '').toUpperCase();
